var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      attrs: { active: _vm.isActive },
      on: {
        "update:active": function ($event) {
          _vm.isActive = $event
        },
      },
    },
    [
      _c(
        "bulma-table",
        {
          staticClass: "table is-bordered is-striped is-narrow is-fullwidth",
          attrs: {
            columns: _vm.columns,
            "page-index": _vm.filter.pageIndex,
            "page-size": _vm.filter.pageSize,
            "total-rows": _vm.totalRows,
            "is-loading": _vm.isTableLoading,
            "sort-column": _vm.filter.sortColumn,
            "sort-order": _vm.filter.sortOrder,
          },
          on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
        },
        [
          _vm._l(_vm.entitySummaries, function (sms, index) {
            return _c(
              "tr",
              {
                key: sms.id,
                class: { "is-selected": _vm.selectedRow === index },
                on: {
                  click: function ($event) {
                    return _vm.highlightSelected(sms, index, $event)
                  },
                },
              },
              [
                _c(
                  "td",
                  {
                    on: {
                      dblclick: function ($event) {
                        return _vm.editMessage(sms, index)
                      },
                    },
                  },
                  [_vm._v(_vm._s(sms.message))]
                ),
                _c(
                  "td",
                  {
                    staticClass:
                      "has-vertical-middle has-text-centered is-content-width",
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "button is-danger is-small is-inverted",
                        attrs: { "data-tooltip": "Click to delete" },
                        on: {
                          click: function ($event) {
                            return _vm.deleteMessage(sms.id, index, sms.message)
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "icon is-medium" }, [
                          _c("i", { staticClass: "mdi mdi-delete mdi-24px" }),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]
            )
          }),
          _c("template", { slot: "empty" }, [
            _c("section", { staticClass: "section" }, [
              _c(
                "div",
                { staticClass: "content has-text-grey has-text-centered" },
                [
                  _c("span", { attrs: { icon: "icon is-large" } }, [
                    _c("i", { staticClass: "mdi mdi-48px mdi-emoticon-sad" }),
                  ]),
                  _c("p", [_vm._v("Nothing")]),
                ]
              ),
            ]),
          ]),
        ],
        2
      ),
      _vm.isEnableSave
        ? _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Message :")]),
            _c("p", { staticClass: "control" }, [
              _c("textarea", {
                directives: [
                  { name: "focus-inserted", rawName: "v-focus-inserted" },
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.smsMessage,
                    expression: "smsMessage",
                  },
                ],
                staticClass: "textarea",
                class: { "is-danger": !_vm.isMessageEntered },
                attrs: {
                  id: "smsMessage",
                  placeholder: "Enter New Message Here...",
                },
                domProps: { value: _vm.smsMessage },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) return
                      _vm.smsMessage = $event.target.value
                    },
                    _vm.enterMessage,
                  ],
                },
              }),
              _vm._v(" "),
              !_vm.isMessageEntered && _vm.isEnableSave
                ? _c("span", { staticClass: "help is-danger" }, [
                    _vm._v("Message is required."),
                  ])
                : _vm._e(),
            ]),
            _c("label", { staticClass: "label" }, [_vm._v("Insert : ")]),
            _c("div", [
              _c(
                "button",
                {
                  staticClass:
                    "button is-small is-rounded is-outlined is-info tooltip",
                  attrs: { "data-tooltip": "Add Name" },
                  on: {
                    click: function ($event) {
                      return _vm.insertTag("[NAME]")
                    },
                  },
                },
                [_c("span", [_vm._v("Name")])]
              ),
              _vm._v("  "),
              _c(
                "button",
                {
                  staticClass:
                    "button is-small is-rounded is-outlined is-info tooltip",
                  attrs: { "data-tooltip": "Add Rego" },
                  on: {
                    click: function ($event) {
                      return _vm.insertTag("[REGO]")
                    },
                  },
                },
                [_c("span", [_vm._v("Rego")])]
              ),
              _vm._v("  "),
              _c(
                "button",
                {
                  staticClass:
                    "button is-small is-rounded is-outlined is-info tooltip",
                  attrs: { "data-tooltip": "Add Excess" },
                  on: {
                    click: function ($event) {
                      return _vm.insertTag("[EXCESS]")
                    },
                  },
                },
                [_c("span", [_vm._v("Excess")])]
              ),
              _vm._v("  "),
              _c(
                "button",
                {
                  staticClass:
                    "button is-small is-rounded is-outlined is-info tooltip",
                  attrs: { "data-tooltip": "Add Estimated Start Date" },
                  on: {
                    click: function ($event) {
                      return _vm.insertTag("[EST START DATE]")
                    },
                  },
                },
                [_c("span", [_vm._v("Estimated Start Date")])]
              ),
              _vm._v("  "),
              _c(
                "button",
                {
                  staticClass:
                    "button is-small is-rounded is-outlined is-info tooltip",
                  attrs: { "data-tooltip": "Add Estimated End Date" },
                  on: {
                    click: function ($event) {
                      return _vm.insertTag("[EST END DATE]")
                    },
                  },
                },
                [_c("span", [_vm._v("Estimated End Date")])]
              ),
              _vm._v("  "),
              _c(
                "button",
                {
                  staticClass:
                    "button is-small is-rounded is-outlined is-info tooltip",
                  attrs: { "data-tooltip": "Add Shop Name" },
                  on: {
                    click: function ($event) {
                      return _vm.insertTag("[SHOPNAME]")
                    },
                  },
                },
                [_c("span", [_vm._v("Shop Name")])]
              ),
            ]),
          ])
        : _vm._e(),
      _vm.entity
        ? _c(
            "unsaved-modal",
            {
              attrs: { active: _vm.isUnsavedModalActive },
              on: {
                "update:active": function ($event) {
                  _vm.isUnsavedModalActive = $event
                },
                close: function ($event) {
                  return _vm.closeModal()
                },
                skipSave: function ($event) {
                  return _vm.skipSave()
                },
                saveContinue: function ($event) {
                  return _vm.saveContinue()
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Unsaved Changes"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _vm._v(
                    "There are unsaved changes. Please select action below"
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm.entity
        ? _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isConfirmModalActive,
                "ok-text": "Yes",
                "cancel-text": "No",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isConfirmModalActive = $event
                },
                ok: function ($event) {
                  return _vm.deleteEntity(true)
                },
                cancel: function ($event) {
                  return _vm.deleteEntity(false)
                },
              },
              model: {
                value: _vm.entity,
                callback: function ($$v) {
                  _vm.entity = $$v
                },
                expression: "entity",
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Delete Message Template"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _vm._v(" Message Template "),
                  _c(
                    "span",
                    { staticClass: "has-text-primary has-text-weight-bold" },
                    [_vm._v(_vm._s(`${_vm.entity.message}`))]
                  ),
                  _vm._v(" will be deleted. Continue? "),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }